import { motion } from "framer-motion";
import podImage from "../assets/pod-design.png";

// Version 2: Price-first, dramatic reveal
const PartnerAd2 = () => {
  return (
    <div className="h-screen bg-background flex flex-col items-center justify-between px-6 py-8 overflow-hidden relative">
      {/* Subtle background glow */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          background: "radial-gradient(circle at 50% 40%, hsl(var(--foreground)) 0%, transparent 60%)"
        }}
      />

      {/* Top spacer */}
      <div />

      {/* Center content - Price first approach */}
      <div className="flex flex-col items-center">
        {/* Lead with the money */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          className="text-muted-foreground text-base mb-2"
        >
          Earn up to
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.25, type: "spring", stiffness: 100 }}
          className="text-center mb-1"
        >
          <p className="font-funnel text-7xl font-bold text-foreground">£3,000</p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.5 }}
          className="text-muted-foreground text-lg mb-6"
        >
          per month
        </motion.p>

        {/* Pod image */}
        <motion.img
          src={podImage}
          alt="qwip soundproof pod"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.7, type: "spring", stiffness: 80 }}
          className="w-32 drop-shadow-xl mb-4"
        />

        {/* Explanation */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.35, delay: 0.95 }}
          className="text-foreground text-center text-lg font-medium leading-snug mb-4"
        >
          Host a qwip pod in your
          <br />
          spare 1m² in London
        </motion.p>

        {/* Trust builder */}
        <motion.span
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35, delay: 1.15 }}
          className="bg-foreground/10 text-foreground text-sm font-medium px-4 py-2 rounded-full"
        >
          Zero upfront cost
        </motion.span>
      </div>

      {/* Bottom: Logo and tagline */}
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 1.3 }}
        className="text-center mb-4"
      >
        <span className="font-funnel text-2xl font-bold text-foreground">qwip</span>
        <p className="font-cormorant italic text-foreground/80 text-lg font-semibold mt-1">
          bookable, quiet pods - wherever you go.
        </p>
      </motion.div>
    </div>
  );
};

export default PartnerAd2;
